import React from "react";
import { FormControl, InputLabel, Box } from "@mui/material";
import CreatableSelect from "react-select/creatable";

// ------------------ CustomCreatableSelect ------------------
const CustomCreatableSelect = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  required,
  error = false,
}) => {
  return (
    <FormControl
      fullWidth
      variant="outlined"
      required={required}
      error={error}
      sx={{ marginBottom: "16px" }}
    >
      <InputLabel shrink>{label}</InputLabel>
      <Box
        sx={{
          border: error ? "1px solid #d32f2f" : "1px solid #ced4da",
          borderRadius: "4px",
          "&:hover": { borderColor: error ? "#d32f2f" : "#1976d2" },
          "&.Mui-focused": { borderColor: error ? "#d32f2f" : "#1976d2" },
        }}
      >
        <CreatableSelect
          isClearable
          options={options}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          styles={{
            control: (provided, state) => ({
              ...provided,
              border: "none",
              boxShadow: "none",
              background: "transparent",
              minHeight: "56px",
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: "6px 14px",
              fontSize: "16px",
            }),
            placeholder: (provided) => ({
              ...provided,
              color: "#9e9e9e",
            }),
            menu: (provided) => ({
              ...provided,
              zIndex: 1300, // Set a higher z-index value
            }),
            menuPortal: (base) => ({
              ...base,
              zIndex: 1300, // This is useful if the select menu is rendered in a portal
            }),
          }}
          menuPortalTarget={document.body} // Optional: render menu in a portal if necessary
        />
      </Box>
    </FormControl>
  );
};

export default CustomCreatableSelect;
